import axios from "axios";

export const saveAppointment = (data, callback) => {
  let method, url;

  if (data.get("interview_appointment[id]")) {
    method = "patch";
    url = `/api/interview_appointments/${data.get("interview_appointment[id]")}`;
  } else {
    method = "post";
    url = "/api/interview_appointments";
  }

  var promise = axios({
    method: method,
    url: url,
    data: data,
    headers: {
      "X-CSRF-TOKEN": window.Hupe8.token
    }
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response || null);
    });
};
